var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 8.33398L15.1232 8.87132C16.2675 9.21465 16.8397 9.38632 17.1692 9.82915C17.4987 10.272 17.4987 10.8694 17.4987 12.0641V18.334",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 7.5H9.16797M6.66797 10.8333H9.16797",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 18.3327V15.8327C9.9987 15.047 9.9987 14.6542 9.75461 14.4101C9.51053 14.166 9.1177 14.166 8.33203 14.166H7.4987C6.71302 14.166 6.32019 14.166 6.07611 14.4101C5.83203 14.6542 5.83203 15.047 5.83203 15.8327V18.3327",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 18.334H18.3346",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.3327V5.59705C2.5 3.50476 2.5 2.45861 3.15932 1.93955C3.81864 1.42049 4.78952 1.70231 6.73127 2.26593L10.8979 3.47537C12.0697 3.81549 12.6556 3.98555 12.9944 4.44906C13.3333 4.91258 13.3333 5.54388 13.3333 6.80649V18.3327",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.260a371bdac6627eeb4090f70b8b45fc.svg";
export { ForwardRef as ReactComponent };